<template>
  <div class="logo is_clickable" @click="handleRedirection">
    <BaseImage :src="headerLogoSrc" alt="logo" />
  </div>
</template>

<script setup>
import BaseImage from '@/components/image/BaseImage.vue';
import useMenuStore from '@/store/modules/menu.js';
import useLogoHook from '@/hooks/useLogo.js';

const menuStore = useMenuStore();

const { headerLogoSrc, redirectToIndexPage } = useLogoHook();

const handleRedirection = () => {
  redirectToIndexPage();

  menuStore.closeMenu();
};
</script>
